<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.salesummary') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item dropdown-filter">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="query.status === null"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="query.status === 'selling'"
                    class="badge badge-info">{{ $t('status.pos.selling') }}</span>
                  <span
                    v-if="query.status === 'closed'"
                    class="badge badge-success">{{ $t('status.pos.closed') }}</span>
                </template>
                <template v-if="query.branch !== null">
                  <span class="badge badge-secondary">
                    {{ selectedBranchName }}
                  </span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group">
                    <label>{{ $t('message.posbranchname') }}</label>
                    <select
                      v-model="query.branch"
                      class="form-control form-control-sm"
                      @change="handleBranchChanged">
                      <option :value="null">{{ $t('message.all') }}</option>
                      <option
                        v-for="(branch, index) in branches"
                        :key="index"
                        :value="branch.branchId"
                      >
                        {{ branch.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group mb-0">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="query.status"
                      class="form-control form-control-sm"
                      @change="handleStatusChanged">
                      <option :value="null">{{ $t('message.all') }}</option>
                      <option
                        value="selling"
                        class="text-info">{{ $t('status.pos.selling') }}</option>
                      <option
                        value="closed"
                        class="text-success">{{ $t('status.pos.closed') }}</option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">
        {{ $t('message.loading') }}
      </p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('apps.pos.message.possession') }}</th>
              <th>{{ $t('apps.pos.message.salestartedtime') }}</th>
              <th>{{ $t('apps.pos.message.saleendedtime') }}</th>
              <th>{{ $t('apps.pos.message.saledurationtime') }}</th>
              <th class="text-center">{{ $t('apps.pos.message.transactions') }}</th>
              <th class="text-center">{{ $t('apps.pos.message.cashier') }}</th>
              <th>{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="posSessions.length === 0"
                colspan="7"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr v-for="(item, index) in posSessions">
              <td>
                <router-link-custom
                  :to="{name: 'PosTransactionDetail', query: {
                    ps_id: item.ps_id,
                    ps_code: item.ps_code
                  }}"
                  :text="item.ps_code"
                  :to_appid="1"
                  :current_appid="1"/>
              </td>
              <td>
                {{ getDateTime(item.started_at) }}
              </td>
              <td>
                <span v-if="item.ended_at">
                  {{ getDateTime(item.ended_at) }}
                </span>
              </td>
              <td>
                {{ getDurationFriendlyBySeconds(
                  (moment(item.ended_at || new Date).format('x') - moment(item.started_at).format('x')) / 1000,
                  $t,
                  false) }}
              </td>
              <td class="text-center">
                {{ item.transactionInfo ? item.transactionInfo.count : 0 }}
              </td>
              <td class="text-center">
                <template v-if="item.user">
                  {{ item.user.email || item.user.username }}
                </template>
              </td>
              <td>
                <template>
                  <span
                    v-if="item.status == 'selling'"
                    class="text-info">
                    {{ $t('status.pos.selling') }}
                  </span>
                  <span
                    v-if="item.status == 'paused'"
                    class="text-warning">
                    {{ $t('status.pos.paused') }}
                  </span>
                  <span
                    v-if="item.status == 'closed'"
                    class="text-success">
                    {{ $t('status.pos.closed') }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'

export default {
  name: 'PosTransactionAll',
  data () {
    return {
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        branch: this.$route.query.branch || null,
        status: this.$route.query.status || null,
      },
    }
  },
  computed: {
    ...mapGetters({
      posSessions: 'getPosSessions',
    }),
    branches () {
      return this.$store.state.posBranch.branches
    },
    selectedBranchName () {
      if (!this.branches.length) {
        return null
      }
      return this.branches.find((branch) => branch.branchId === this.query.branch).name
    },
  },
  watch: {
    ready: function () {
      if (this.ready) {
        this.showFinish(this.$Progress)
      }
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = undefined
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 0,
    })
  },
  destroyed () {
    this.leavePage(this.$Progress, ['clearPosSessions'])
  },
  methods: {
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getPosBranches')
      await this.$store.dispatch('getPosSessions', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        branch_id: this.query.branch,
        status: this.query.status,
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
    handleBranchChanged () {
      this.query.page = 1
      this.fetchData()
      // hide dropdown
      if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
        $('button.filter').dropdown('toggle')
      }
    },
    handleStatusChanged () {
      this.query.page = 1
      this.fetchData()
      // hide dropdown
      if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
        $('button.filter').dropdown('toggle')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/pos/transaction/All.vue